export default "__VITE_ASSET__CKO2_6I___"